<template>
  <div>
    <p
      class="text-sm text-error-500"
      v-for="(error, index) in errors"
      :key="index"
    >
      {{ error }}
    </p>
  </div>
</template>

<script>
export default {
  props: ["errors"],
};
</script>